import { Fragment, useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import ButtonCommon from "../../components/ButtonCommon";
import './index.scss';
import { getVerificationStatus, saveVerificationStatus, getUserStatus, logout, getUserDetail, linkPartner } from '../../api/onboarding';
import { setToLocalStorage } from '../../utils/Helpers'
import { SSO_auth_path } from '../../config';
import Header from "../../components/Header";

const Verification = (props) => {
	const [loading, setLoading] = useState(false);
	const [authData, setAuthData] = useState(null)

	useEffect(() => {
		setLoading(true);
		const urlParams = new URLSearchParams(window.location.search);
    	const partnerToken = urlParams.get('token');
		
		getUserDetail().then( (res) => {
			window.$crisp.push(["set", "user:email", [res.emailId]])
			if(res.phoneNumber) {
				window.$crisp.push(["set", "user:phone", [res.phoneNumber]])
			}
		});
		getVerificationStatus(partnerToken).then(res => {
			setAuthData(res);
			getUserStatus().then(async status => {
				setLoading(false);
				if (status.userState === 'NEW_USER' && partnerToken) {
					await linkPartner(partnerToken)
				}
				if (status.userState === 'CREDITLINE_ACTIVATED' || status.userState === 'LOAN_APPLICATION_COMPLETED') {
					setToLocalStorage('token', {step: 'dashboard'});
					props.history.replace({pathname: '/dashboard', search: props.location.search});
				} else if (status.userState !== 'NEW_USER' && res.emailWhitelisted) {
					goToOnboarding();
				} else if (status.userState === 'NEW_USER' && res.emailWhitelisted && (!res.oldGstUser && !res.taxExpert)) {
					goToOnboarding('continue');
				}
			})
		})
	},[])

	if(loading){
		return (
			<div className="loading">
				<CircularProgress />
			</div>
		)
	}

	const goToOnboarding = (isContinue) => {
		if (isContinue) {
			saveVerificationStatus();
		}
		setToLocalStorage('token', {step: 'register'});
		props.history.replace({pathname: '/register', search: props.location.search})
	}

	const anotherLogin = () => {
		setLoading(true);
		let stingToConvert = '/verification'
		const urlParams = new URLSearchParams(window.location.search);
		const partnerToken = urlParams.get('token');
		if (partnerToken) {
		stingToConvert += '?token='+partnerToken;
		}
		let redirectUrl = btoa(stingToConvert)
		logout().then(res => {
			setLoading(false);
			window.location.href = `${SSO_auth_path}&return_path=${redirectUrl}`;
		})
	}

	const renderScreen = () => {
		if (!authData?.emailWhitelisted) {
			return <div className="pageBox">
				<div className="pageContent">
					<h4>Currently we have enabled GST PayLater for selected users only. <a onClick={() => window.$crisp.push(['do', 'chat:open'])}>Chat with Us</a> for further assistance</h4>
					<h3>
						<img src="favicon_32x32.png" />
						{authData?.email}
					</h3>
					<div className="btnBox">
						<ButtonCommon title="Login with another email" onClick={() => anotherLogin()} style={{marginTop: 0}} />
					</div>
				</div>
			</div>
		} else if (authData?.taxExpert) {
			return <div className="pageBox">
				<div className="pageContent">
					<h4>Email ID belongs to a Tax Expert.</h4>
					<h3>
						<img src="favicon_32x32.png" />
						{authData?.email}
					</h3>
					<p>You are trying to login with an email ID which belongs to a Tax Expert in ClearGST. Please use applicant email ID to login.</p>
					<div className="btnBox">
						<ButtonCommon title="Login with another email" onClick={() => anotherLogin()} style={{marginTop: 0}} />
					</div>
				</div>
			</div>
		} else if (authData?.oldGstUser ) {
			return <div className="pageBox">
				<div className="pageContent">
					<h4>Continue applying using existing account?</h4>
					<h3>
						<img src="favicon_32x32.png" />
						{authData?.email}
					</h3>
					<p>Since this email ID already exists in ClearGST application. Do you want to continue applying for a loan using this email?</p>
					<div className="btnBox">
						<ButtonCommon className="invert" title="Login with another email" onClick={() => anotherLogin()} style={{marginTop: 0}} />
						<ButtonCommon title="Continue" style={{marginTop: 0}} onClick={() => goToOnboarding('continue')} />
					</div>
				</div>
			</div>
		}
	}

	return(
		<Fragment>
			<Header props={props} />
			{renderScreen()}
		</Fragment>
	)
}

export default Verification;